import { collection, getDocs } from "firebase/firestore";
import { FirebaseCollectionEnum } from "lib/constants/firebase";
import { db } from "lib/services/firebase";

export const getOccasions = async () =>
  getDocs(collection(db, FirebaseCollectionEnum.OCCASIONS));
